import { ReviewCard } from "./reviewCard";

export const review = {
    ReviewCard
}